import React, { useEffect, useState } from 'react';
import './globals.css';
import './styles/animations.css'
import Layout from './hoc/Layout/Layout';
import { Routes, Route } from 'react-router-dom';

import paths from './config/paths';
import Home from './containers/Home/Home'
import Skills from './containers/Skills/Skills';
import Projects from './containers/Projects/Projects';
import Contact from './containers/Contact/Contact';

import QuaiAntique from './containers/Projects/quai_antique/QuaiAntique';
import CharlesCantin from './containers/Projects/charles_cantin/CharlesCantin';
import DesAventures from './containers/Projects/dés_aventures/DesAventures';
import RollinBattle from './containers/Projects/rollin_battle/RollinBattle';
import Memory from './containers/Projects/memory/Memory';
import MyLittlePony from './containers/Projects/mlp/MyLittlePony';
import Codepen from './containers/Projects/codepen/Codepen';


function App() {
  const [homeVisited, setHomeVisited] = useState(false)
  const [skillsVisited, setSkillsVisited] = useState(false)
  const [projectsVisited, setProjectsVisited] = useState(false)
  const [contactVisited, setContactVisited] = useState(false)

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const nav = () => {
    if (isMenuOpen) {
      setIsMenuOpen(false)
    }
  }

  useEffect(() => {
    const page = window.location.pathname;

    switch(page) {
      case '/skills':
        setTimeout(() => {
          setSkillsVisited(true);
        }, 3000);
        break;
      case '/projects': 
        setTimeout(() => {
          setProjectsVisited(true);
        }, 3000);
        break;
      case '/contact': 
        setTimeout(() => {
          setContactVisited(true);
        }, 3000);
        break;
      case '/':
      default:
        setTimeout(() => {
          setHomeVisited(true);
        }, 3000);
        break;
    }
  },[])

  const handleHome = () => {
    nav();
    setTimeout(() => {
      setHomeVisited(true)
    }, 3000);
  }
  const handleSkills = () => {
    nav()
    setTimeout(() => {
      setSkillsVisited(true)
    }, 3000);
  }
  const handleProjects = () => {
    nav()
    setTimeout(() => {
      setProjectsVisited(true)
    }, 3000);
  }
  const handleContact = () => {
    nav()
    setTimeout(() => {
      setContactVisited(true)
    }, 3000);
  }
  const handleProject = () => {
    nav()
  }
  const handleMenu = () => {
    setIsMenuOpen(prevIsMenuopen => !prevIsMenuopen);
  }

  return (

    <div className='App'>
      <Layout handleHome={handleHome} 
              handleSkills={handleSkills} 
              handleProjects={handleProjects} 
              handleContact={handleContact}
              isMenuOpen= {isMenuOpen}
              handleMenu={handleMenu}>
        <Routes>
          <Route path={paths.HOME} element={<Home visited={homeVisited}></Home>}></Route>
          <Route path={paths.SKILLS} element={<Skills visited={skillsVisited}></Skills>}></Route>
          <Route path={paths.PROJECTS} element={<Projects visited={projectsVisited}></Projects>}></Route>
          <Route path={paths.QUAI_ANTIQUE} element={<QuaiAntique visited={handleProject}></QuaiAntique>}></Route>
          <Route path={paths.CHARLES_CANTIN} element={<CharlesCantin visited={handleProject}></CharlesCantin>}></Route>
          <Route path={paths.DES_AVENTURES} element={<DesAventures visited={handleProject}></DesAventures>}></Route>
          <Route path={paths.ROLLIN_BATTLE} element={<RollinBattle visited={handleProject}></RollinBattle>}></Route>
          <Route path={paths.MEMORY} element={<Memory visited={handleProject}></Memory>}></Route>
          <Route path={paths.MLP} element={<MyLittlePony visited={handleProject}></MyLittlePony>}></Route>
          <Route path={paths.CODEPEN} element={<Codepen visited={handleProject}></Codepen>}></Route>
          <Route path={paths.CONTACT} element={<Contact visited={contactVisited}></Contact>}></Route>
        </Routes>
      </Layout>
    </div>
  );
}

export default App;
